// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
/**
 *
 * @export
 * @interface BuildPayload
 */
export interface BuildPayload {
  /**
   * Human-facing version identifier of the software the tests run against. Stored trimmed, and must contain at least one letter or number — a value made only of whitespace or punctuation (\" \", \"-\", \".\") is rejected with a 400 (TCV-6806).
   * @type {string}
   * @memberof BuildPayload
   */
  version: string;
  /**
   * Free-form environment name (e.g. Production, Staging, UAT). Optional — omit the key to leave it unchanged, or send an empty string to clear it. Any other value is stored trimmed and must contain at least one letter or number (TCV-6806).
   * @type {string}
   * @memberof BuildPayload
   */
  environment?: string;
  /**
   *
   * @type {string}
   * @memberof BuildPayload
   */
  releaseDate?: string;
  /**
   *
   * @type {string}
   * @memberof BuildPayload
   */
  notes?: string;
  /**
   *
   * @type {string}
   * @memberof BuildPayload
   */
  releaseNotesUrl?: string;
  /**
   * How the build was created. Defaults to `manual` when omitted.
   * @type {string}
   * @memberof BuildPayload
   */
  source?: BuildPayloadSourceEnum;
  /**
   *
   * @type {string}
   * @memberof BuildPayload
   */
  vcsProvider?: string;
  /**
   *
   * @type {string}
   * @memberof BuildPayload
   */
  ciProvider?: string;
  /**
   *
   * @type {string}
   * @memberof BuildPayload
   */
  commitSha?: string;
  /**
   *
   * @type {string}
   * @memberof BuildPayload
   */
  branch?: string;
  /**
   *
   * @type {string}
   * @memberof BuildPayload
   */
  tag?: string;
  /**
   *
   * @type {string}
   * @memberof BuildPayload
   */
  repoUrl?: string;
  /**
   *
   * @type {string}
   * @memberof BuildPayload
   */
  commitUrl?: string;
  /**
   *
   * @type {string}
   * @memberof BuildPayload
   */
  buildNumber?: string;
  /**
   *
   * @type {string}
   * @memberof BuildPayload
   */
  buildUrl?: string;
  /**
   *
   * @type {string}
   * @memberof BuildPayload
   */
  externalRef?: string;
  /**
   * Provider-specific fields
   * @type {{ [key: string]: any; }}
   * @memberof BuildPayload
   */
  metadata?: { [key: string]: any };
  /**
   * Release ID to assign this build to manually (optional; send null to unlink). A manual assignment overrides pattern auto-matching (TCV-6723).
   * @type {number}
   * @memberof BuildPayload
   */
  release?: number;
  /**
   *
   * @type {number}
   * @memberof BuildPayload
   */
  project: number;
}

export function BuildPayloadFromJSON(json: any): BuildPayload {
  return {
    version: json["version"],
    environment: !exists(json, "environment") ? undefined : json["environment"],
    releaseDate: !exists(json, "release_date")
      ? undefined
      : json["release_date"],
    notes: !exists(json, "notes") ? undefined : json["notes"],
    releaseNotesUrl: !exists(json, "release_notes_url")
      ? undefined
      : json["release_notes_url"],
    source: !exists(json, "source") ? undefined : json["source"],
    vcsProvider: !exists(json, "vcs_provider")
      ? undefined
      : json["vcs_provider"],
    ciProvider: !exists(json, "ci_provider") ? undefined : json["ci_provider"],
    commitSha: !exists(json, "commit_sha") ? undefined : json["commit_sha"],
    branch: !exists(json, "branch") ? undefined : json["branch"],
    tag: !exists(json, "tag") ? undefined : json["tag"],
    repoUrl: !exists(json, "repo_url") ? undefined : json["repo_url"],
    commitUrl: !exists(json, "commit_url") ? undefined : json["commit_url"],
    buildNumber: !exists(json, "build_number")
      ? undefined
      : json["build_number"],
    buildUrl: !exists(json, "build_url") ? undefined : json["build_url"],
    externalRef: !exists(json, "external_ref")
      ? undefined
      : json["external_ref"],
    metadata: !exists(json, "metadata") ? undefined : json["metadata"],
    release: !exists(json, "release") ? undefined : json["release"],
    project: json["project"],
  };
}

export function BuildPayloadToJSON(value?: BuildPayload): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    version: value.version,
    environment: value.environment,
    release_date: value.releaseDate,
    notes: value.notes,
    release_notes_url: value.releaseNotesUrl,
    source: value.source,
    vcs_provider: value.vcsProvider,
    ci_provider: value.ciProvider,
    commit_sha: value.commitSha,
    branch: value.branch,
    tag: value.tag,
    repo_url: value.repoUrl,
    commit_url: value.commitUrl,
    build_number: value.buildNumber,
    build_url: value.buildUrl,
    external_ref: value.externalRef,
    metadata: value.metadata,
    release: value.release,
    project: value.project,
  };
}

/**
 * @export
 * @enum {string}
 */
export enum BuildPayloadSourceEnum {
  Manual = "manual",
  Ci = "ci",
}
